import React from 'react';
import { Divider, SparkIcon } from '@spark';
import './settings.css';

/**
 * Shared section container for every Settings tab (Figma frames 6001-261 …):
 * 24px icon + 20px/28px semibold title (8px gap), optional header actions,
 * full-width divider, then the section body inside a 16px column, all
 * padded 16/24/24.
 *
 * ``iconSlug`` is optional: a section whose brand mark sits in
 * ``headerExtra`` (see TavilyApiKey) omits it rather than stacking two glyphs.
 */
const SettingsSectionCard = ({ iconSlug, title, headerExtra, children }) => (
    <div className="settings-section">
        <div className="settings-section__header">
            <div className="settings-section__heading">
                {iconSlug ? <SparkIcon slug={iconSlug} size="medium" /> : null}
                <h2 className="settings-section__title fs-unmask">{title}</h2>
            </div>
            {headerExtra ? (
                <div className="settings-section__actions">{headerExtra}</div>
            ) : null}
        </div>
        <Divider />
        {children}
    </div>
);

export default SettingsSectionCard;
